import React from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { globalActions } from "../../../views/shared-screens/redux/actions";
import {
  importOrdersConstants,
} from "../../../views/shared-screens/constants";
import { ButtonSpinner } from "../spinner/buttonSpinner";
import { useSpinner } from "../hooks";

const ImportOrderButton = (props) => {
  const { importOrderFromFR } = props;
  const { IMPORT_ORDER_DATA, IMPORT_ORDERS } = importOrdersConstants;

  const importOrders = () => {
    importOrderFromFR();
  };

  // Show loading while a request is running.
  const spinner = useSpinner();

  return (
    <>
      {spinner(IMPORT_ORDER_DATA) ? (
        <div className="d-flex justify-content-end me-3 mt-2">
          <ButtonSpinner buttonText={IMPORT_ORDERS} />
        </div>
      ) : (
        <div className="d-flex justify-content-end me-3 mt-2">
          <Button variant="primary" onClick={() => importOrders()}>
            {IMPORT_ORDERS}
          </Button>
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  importOrderFromFR: () => dispatch(globalActions.importOrdersFromFR()),
});

export default connect(null, mapDispatchToProps)(ImportOrderButton);
